import React from 'react'
import TeamDashboardContainer from 'containers/TeamDashboard'
import PropTypes from 'prop-types'

const TeamDashboard = ({ history, changeTab }) => (
  <TeamDashboardContainer history={history} changeTab={changeTab} />
)

TeamDashboard.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
changeTab: PropTypes.func.isRequired,
}

export default TeamDashboard
